import { Form } from '@weave/schema-gen-ts/dist/schemas/forms-digital/weave_digital_forms.pb';
import { Link } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Button, TextLink } from '@frontend/design-system';
import { SectionBase } from '../../../content-composer/section-base/section-base';

type Props = {
  documents: Form[];
  editLink: () => void;
  link?: Link;
  removeLink: () => void;
};

export const SelectedToolbar = ({ documents, editLink, link, removeLink }: Props) => {
  const { t } = useTranslation('content-composer');

  const getLabel = () => {
    switch (link?.linkType) {
      case 'form':
        return documents.find((document) => document.id === link.url)?.name;
      case 'schedule':
        return t('Schedule');
      case 'confirmation':
        return t('Confirmation');
      case 'phone':
        return t('Practice Phone');
      case 'address':
        return t('Practice Address');
      case 'custom':
      default:
        return link?.url;
    }
  };

  const getIcon = () => {
    switch (link?.linkType) {
      case 'form':
        return 'forms-small';
      case 'address':
        return 'building-small';
      case 'confirmation':
        return 'link-small';
      case 'phone':
        return 'phone-small';
      case 'schedule':
        return 'schedule-pulse-small';
      default:
        return 'link-small';
    }
  };

  return (
    <SectionBase.Toolbar.Tool css={{ padding: theme.spacing(0, 0, 0, 1) }}>
      <Icon name={getIcon()} css={{ marginRight: theme.spacing(0.5) }} />
      <TextLink
        onClick={editLink}
        css={{
          color: theme.colors.neutral70,
          textDecoration: 'underline',
          transition: 'all 250ms ease',
          ':hover, :focus': { color: theme.colors.primary50 },
        }}
      >
        {getLabel()}
      </TextLink>
      <Button
        iconName='x-small'
        variant='secondary'
        size='small'
        onClick={removeLink}
        css={{
          borderBottomLeftRadius: 0,
          borderLeft: `solid 1px ${theme.colors.neutral20}`,
          borderTopLeftRadius: 0,
          marginLeft: theme.spacing(1),
          svg: { color: theme.colors.neutral70 },
          ':hover, :focus': { color: theme.colors.neutral10 },
        }}
      />
    </SectionBase.Toolbar.Tool>
  );
};
